import React, { Fragment } from "react";
import PropTypes from "prop-types";
import Sidebar from "./Sidebar";
import MobileBottomNav from "./MobileBottomNav";
import NotificationHeader from "./NotificationHeader";
import notificationPropsType from "./NotificationHeader/types/notificationPropsType";
import mobileBottomNavType from "./MobileBottomNav/types/mobileBottomNavType";
import menuItemsType from "./Sidebar/types/menuItemsType";

const Navigation = ({ headerProps, sidebarProps, mobileBottomNavProps }) => (
  <Fragment>
    <NotificationHeader {...headerProps} />
    <Sidebar {...sidebarProps} />
    <MobileBottomNav {...mobileBottomNavProps} />
  </Fragment>
);

Navigation.propTypes = {
  headerProps: notificationPropsType.isRequired,
  sidebarProps: PropTypes.shape({
    engagementCredits: PropTypes.number,
    jobCredits: PropTypes.number,
    menuItems: menuItemsType.isRequired,
  }).isRequired,
  mobileBottomNavProps: mobileBottomNavType.isRequired,
};

export default Navigation;
